import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["colspan"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "text-right"
}
const _hoisted_6 = {
  key: 1,
  class: "text-right"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "text-right"
}
const _hoisted_10 = {
  key: 1,
  class: "text-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_AccountableAccountBalanceDetail = _resolveComponent("AccountableAccountBalanceDetail")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: "",
    class: "py-0"
  }, {
    default: _withCtx(() => [
      (_ctx.isAuthorized)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables, (table, ti) => {
              return (_openBlock(), _createElementBlock("div", {
                "align-center": "",
                key: ti
              }, [
                _createVNode(_component_v_row, { class: "d-flex justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: _ctx.firstColumnWidth,
                      class: "d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h1", null, _toDisplayString(table.name), 1),
                        _createVNode(_component_v_btn_icon, {
                          icon: "$oss-download",
                          onClick: _withModifiers(($event: any) => (_ctx.download(table)), ["stop"]),
                          class: "ml-2"
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_v_btn_icon, {
                          icon: "$oss-duplicate",
                          onClick: _withModifiers(($event: any) => (_ctx.copy(table)), ["stop"])
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["cols"]),
                    (_ctx.displayAccountingAvailabilityDate)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.accountingAvailabilityDate,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.accountingAvailabilityDate) = $event)),
                              items: _ctx.endPublishDates,
                              "item-value": "value",
                              label: "Publication au client",
                              elevation: "0",
                              "hide-details": "",
                              disabled: _ctx.disabledPublishDate,
                              class: "pl-2 flex-shrink-1 flex-grow-0",
                              density: "compact"
                            }, null, 8, ["modelValue", "items", "disabled"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.hasBeenCustomed)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 1,
                          cols: "2",
                          class: "d-flex justify-end align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              rounded: "",
                              elevation: "0",
                              class: "ml-2 mb-1",
                              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.resetAllCustomAmounts()), ["stop"])),
                              size: "x-small"
                            }, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createTextVNode(" Revenir aux valeurs comptables ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_row, { class: "d-flex justify-center mt-0" }, {
                  default: _withCtx(() => [
                    (_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: _ctx.displayMonthlyData ? '12' : '8',
                          class: "d-flex justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_progress_circular, {
                              indeterminate: "",
                              color: "primary",
                              class: "mr-3 d-flex justify-center"
                            })
                          ]),
                          _: 1
                        }, 8, ["cols"]))
                      : (_openBlock(), _createBlock(_component_v_col, {
                          key: 1,
                          cols: _ctx.displayMonthlyData ? '12' : _ctx.currentKey === 'Bilan' ? '10' : '8',
                          class: "d-flex justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_data_table, {
                              headers: _ctx.getHeaders(table),
                              items: table.rows,
                              height: `min(${_ctx.numberVisibleLignes(table) * 38 + 2}px, ${_ctx.maxHeight})`,
                              class: "table",
                              "fixed-header": "",
                              "hide-default-footer": "",
                              "items-per-page": -1,
                              "item-value": "key",
                              density: "compact"
                            }, {
                              item: _withCtx(({ item }) => [
                                (item.title && !item.total)
                                  ? (_openBlock(), _createElementBlock("tr", {
                                      key: 0,
                                      class: "text-left",
                                      style: _normalizeStyle(_ctx.itemRowBackground(item))
                                    }, [
                                      _createElementVNode("td", null, [
                                        _createElementVNode("strong", null, _toDisplayString(item.title), 1)
                                      ]),
                                      _createElementVNode("td", {
                                        colspan: _ctx.getColumnCount(table)
                                      }, null, 8, _hoisted_1)
                                    ], 4))
                                  : (_ctx.withAmountOrNotOptional(item))
                                    ? (_openBlock(), _createElementBlock("tr", {
                                        key: 1,
                                        style: _normalizeStyle(_ctx.itemRowBackground(item)),
                                        onClick: _withModifiers(($event: any) => (_ctx.displayRowDetail(item)), ["stop"])
                                      }, [
                                        _createElementVNode("td", {
                                          class: "text-left",
                                          style: _normalizeStyle(_ctx.colorElement(item))
                                        }, _toDisplayString(item.name || item.title), 5),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultPeriods, (period, pi) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                                            (period.monthly)
                                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.monthsToDisplay, (month, index) => {
                                                  return (_openBlock(), _createElementBlock("td", {
                                                    class: "text-right pl-1",
                                                    key: ti + '-' + pi + '-month' + index,
                                                    onClick: _withModifiers(($event: any) => (
                                                    _ctx.openEditCell(table, item, 0, pi, index)
                                                ), ["stop"]),
                                                    style: _normalizeStyle(_ctx.getCellStyle(table, item, 0, pi, index))
                                                  }, _toDisplayString(_ctx.getAmountFormatted(
                                                        table,
                                                        item,
                                                        table.columns[0],
                                                        pi,
                                                        index,
                                                    )), 13, _hoisted_3))
                                                }), 128))
                                              : _createCommentVNode("", true),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.columnsToDisplay[pi], (col, ci) => {
                                              return (_openBlock(), _createElementBlock("td", {
                                                class: "text-right",
                                                key: ti + '-' + pi + '-' + ci,
                                                onClick: _withModifiers(($event: any) => (_ctx.openEditCell(table, item, ci, pi)), ["stop"]),
                                                style: _normalizeStyle(_ctx.getCellStyle(table, item, ci, pi))
                                              }, _toDisplayString(_ctx.getAmountFormatted(table, item, col, pi)), 13, _hoisted_4))
                                            }), 128)),
                                            (table.getPercentageOfTotal && !_ctx.displayMonthlyData)
                                              ? (_openBlock(), _createElementBlock("td", {
                                                  class: "text-right",
                                                  key: ti + '-' + pi + '-relativePercentageMaxime'
                                                }, _toDisplayString(_ctx.getFormatedPercentageOfTotal(item, table, pi)), 1))
                                              : _createCommentVNode("", true),
                                            (table.relativePercentage && !_ctx.displayMonthlyData)
                                              ? (_openBlock(), _createElementBlock("td", {
                                                  class: "text-right",
                                                  key: ti + '-' + pi + '-relativePercentage'
                                                }, _toDisplayString(_ctx.getRelativePercentage(item, pi)), 1))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 256)),
                                        (
                                            table.comparison &&
                                            table.comparison.difference &&
                                            !_ctx.displayMonthlyData
                                        )
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_5, _toDisplayString(_ctx.formatDifference(item)), 1))
                                          : _createCommentVNode("", true),
                                        (
                                            table.comparison &&
                                            table.comparison.percentage &&
                                            !_ctx.displayMonthlyData
                                        )
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(_ctx.formatPercentage(item.percentage)), 1))
                                          : _createCommentVNode("", true),
                                        (table.extraColumns && !_ctx.displayMonthlyData)
                                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(table.extraColumns, (column) => {
                                              return (_openBlock(), _createElementBlock("td", {
                                                class: "text-right",
                                                key: column.name
                                              }, _toDisplayString(_ctx.getExtraColumnsValue(item, column.name)), 1))
                                            }), 128))
                                          : _createCommentVNode("", true)
                                      ], 12, _hoisted_2))
                                    : _createCommentVNode("", true),
                                (item.isExpanded && item.subRows && item.subRows.length)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(item.subRows, (subrow, subR) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: ti + '-' + item.name + '-' + subR,
                                        class: "elevation-1 border-0",
                                        style: {"cursor":"pointer"}
                                      }, [
                                        _createElementVNode("td", {
                                          class: "text-left font-italic",
                                          onClick: ($event: any) => (_ctx.openAABDetailDialog(subrow.name, subrow))
                                        }, "      " + _toDisplayString(subrow.name + " - " + subrow.description), 9, _hoisted_7),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultPeriods, (period, pi) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                                            (period.monthly && _ctx.monthsToDisplay)
                                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.monthsToDisplay, (month, index) => {
                                                  return (_openBlock(), _createElementBlock("td", {
                                                    key: 
                                                        ti +
                                                        '-' +
                                                        item.name +
                                                        '-' +
                                                        pi +
                                                        '-' +
                                                        subR +
                                                        '-' +
                                                        index
                                                    ,
                                                    class: "text-right font-italic"
                                                  }, _toDisplayString(_ctx.getSubMonthlyAmount(
                                                            table,
                                                            item,
                                                            subrow,
                                                            pi,
                                                            index,
                                                        )), 1))
                                                }), 128))
                                              : _createCommentVNode("", true),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.columnsToDisplay[pi], (col, ci) => {
                                              return (_openBlock(), _createElementBlock("td", {
                                                key: ti + '-' + pi + '-' + ci + '-' + subR,
                                                class: "text-right font-italic",
                                                onClick: _withModifiers(($event: any) => (
                                                    _ctx.openEditCell(
                                                        table,
                                                        item,
                                                        ci,
                                                        pi,
                                                        undefined,
                                                        subrow,
                                                    )
                                                ), ["stop"]),
                                                style: _normalizeStyle(
                                                    _ctx.getCellStyle(
                                                        table,
                                                        item,
                                                        ci,
                                                        pi,
                                                        undefined,
                                                        subrow,
                                                    )
                                                )
                                              }, _toDisplayString(_ctx.getAmountFormatted(
                                                        table,
                                                        item,
                                                        col,
                                                        pi,
                                                        undefined,
                                                        subrow,
                                                    )), 13, _hoisted_8))
                                            }), 128)),
                                            (
                                                    table.getPercentageOfTotal &&
                                                    !_ctx.displayMonthlyData
                                                )
                                              ? (_openBlock(), _createElementBlock("td", {
                                                  class: "text-right",
                                                  key: ti + '-' + pi + '-relativePercentageMaxime'
                                                }, _toDisplayString("")))
                                              : _createCommentVNode("", true),
                                            (table.relativePercentage)
                                              ? (_openBlock(), _createElementBlock("td", {
                                                  class: "text-right",
                                                  key: 
                                                    ti +
                                                    '-' +
                                                    pi +
                                                    '-relativePercentage' +
                                                    '-' +
                                                    subR
                                                
                                                }, _toDisplayString(_ctx.getRelativePercentage(subrow, pi)), 1))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 256)),
                                        (table.comparison && table.comparison.difference)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_9))
                                          : _createCommentVNode("", true),
                                        (table.comparison && table.comparison.percentage)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_10))
                                          : _createCommentVNode("", true),
                                        (table.extraColumns)
                                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(table.extraColumns, (column) => {
                                              return (_openBlock(), _createElementBlock("td", {
                                                class: "text-right",
                                                key: column.name
                                              }))
                                            }), 128))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["headers", "items", "height"])
                          ]),
                          _: 2
                        }, 1032, ["cols"]))
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128)),
            (_ctx.AABDialog)
              ? (_openBlock(), _createBlock(_component_oss_dialog, {
                  key: 0,
                  modelValue: _ctx.AABDialog,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.AABDialog) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_AccountableAccountBalanceDetail, {
                              companyId: _ctx.companyId,
                              accountingPeriodId: _ctx.accountingPeriodId,
                              accountableAccountInfo: _ctx.accountableAccountInfo,
                              startDate: _ctx.date.start,
                              endDate: _ctx.date.end,
                              onRefresh: _ctx.refresh
                            }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountInfo", "startDate", "endDate", "onRefresh"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (_ctx.showEditCellDialog)
              ? (_openBlock(), _createBlock(_component_oss_dialog, {
                  key: 1,
                  modelValue: _ctx.showEditCellDialog,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showEditCellDialog) = $event)),
                  title: "Edition",
                  onValid: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveEditCell())),
                  width: "500px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field_filled, {
                              label: "Montant",
                              "single-line": "",
                              class: "mt-2",
                              autofocus: "",
                              modelValue: _ctx.cellToEdit.value,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cellToEdit.value) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "d-flex justify-end"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.ifCellToEditAlreadyModified)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 0,
                                  onClick: _withModifiers(_ctx.resetCustomAmount, ["stop"]),
                                  size: "x-small"
                                }, {
                                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                                    _createTextVNode(" Réinitialiser la valeur ")
                                  ])),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}